
import React from 'react';
import { useRSVP } from '../../context/RSVPContext';
import { RSVPHeader } from '../RSVPHeader';
import { RSVPStepContainer } from '../RSVPStepContainer';
import { RSVPNavigation } from '../RSVPNavigation';
import { EventData, GuestData } from '../../types';

interface UpdateRSVPContentProps {
  eventData: EventData;
  availableGuests?: GuestData[];
  respondedGuests?: GuestData[];
  inProgressGuests?: GuestData[];
}

export const UpdateRSVPContent: React.FC<UpdateRSVPContentProps> = ({ 
  eventData,
  availableGuests = [],
  respondedGuests = [],
  inProgressGuests = []
}) => {
  const { currentState } = useRSVP();

  // Get the host's first name
  const hostName = eventData?.hostName 
    ? eventData.hostName.split(' ')[0] 
    : 'Your host';

  return (
    <div className="flex flex-col min-h-screen">
      <RSVPHeader 
        eventName={eventData?.name || 'Event'} 
        hostName={eventData?.hostName || 'Host'} 
        currentState={currentState}
        isUpdate={true}
      />
      
      <div className="flex-grow">
        <RSVPStepContainer 
          currentState={currentState} 
          eventData={eventData!}
          availableGuests={availableGuests}
          respondedGuests={respondedGuests}
          inProgressGuests={inProgressGuests} 
        />
      </div>
      
      <RSVPNavigation 
        currentState={currentState} 
      />
    </div>
  );
};
